var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFundoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 831,
    height: 901,
    viewBox: "0 0 831 901",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.767 218.673C380.448 220.223 378.258 220.752 376.358 219.982L33.8429 81.0148C29.4026 79.2136 30.2282 72.7979 34.985 72.1413L557.265 0.0487281C561.539 -0.541397 564.303 4.36036 561.531 7.61531L381.767 218.673Z",
    fill: "#9DC8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M466.635 544.255C465.319 545.804 463.136 546.331 461.243 545.562L2.90798 359.308C-1.51844 357.509 -0.695322 351.103 4.04646 350.448L702.931 253.824C707.191 253.235 709.947 258.129 707.185 261.377L466.635 544.255Z",
    fill: "#288ECD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M547.104 899.347C545.788 900.891 543.608 901.419 541.715 900.651L2.90632 682.003C-1.51756 680.208 -0.69494 673.815 4.04417 673.161L825.638 559.731C829.896 559.144 832.651 564.029 829.89 567.271L547.104 899.347Z",
    fill: "#242D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFundoColor);
export default __webpack_public_path__ + "static/media/logo-fundo-color.272955d336f5901cb9ee15666f2fd08d.svg";
export { ForwardRef as ReactComponent };